import AES from 'crypto-js/aes';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';

const salt = 'lkjh12';

export const encrypt = (value: string): string =>
  AES.encrypt(value, salt).toString();

export const decrypt = (value: string): string =>
  AES.decrypt(value, salt).toString(Utf8);

export function decryptWithParse<T = any>(
  word: string,
  key: string
): T | undefined {
  try {
    const decData = Base64.parse(word).toString(Utf8);
    const bytes = AES.decrypt(decData, key).toString(Utf8);
    return JSON.parse(bytes);
  } catch {
    return;
  }
}
